function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable */

import { nodeArray, loopObject, containsClass, Event } from '@meteora-digital/helpers';
var ajax = require('../functions/ajax');
var Filters = /*#__PURE__*/function () {
  function Filters(container) {
    var _this = this;
    _classCallCheck(this, Filters);
    this.section = container;
    this.contentAreas = nodeArray(this.section.querySelectorAll('.js-filter--content'));
    // this.url = this.section.getAttribute('data-api');
    this.lists = nodeArray(this.section.querySelectorAll('.js-filter--list'));
    this.equalizers = nodeArray(this.section.querySelectorAll('.js-filter--content[data-equalize]'));
    this.filters = {};
    this.timeout = null;
    this.filterEvent = new Event('filtered');
    this.pagination();
    try {
      this.url = this.section.getAttribute('data-api').replace('?stage=Stage', '');
    } catch (e) {
      this.url = this.section.getAttribute('data-api');
    }
    this.lists.forEach(function (list) {
      _this.filters[list.getAttribute('data-filter-name')] = {
        type: list.getAttribute('data-filter-type'),
        value: [],
        controllers: {
          checkboxes: nodeArray(list.querySelectorAll('.js-filter--checkbox')),
          select: list.querySelector('.js-filter--select')
        }
      };
    });
    loopObject(this.filters, function (name, settings) {
      settings.controllers.checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          // Reset the filter value
          settings.value = [];

          // If we allow for multiple values
          if (settings.type === 'multiple') {
            // Disabling the filter
            if (containsClass(checkbox, 'js-active')) {
              checkbox.classList.remove('js-active');
              checkbox.blur();
            }
            // Enabling the filter
            else {
              checkbox.classList.add('js-active');
            }
          }
          // If it is only a single value
          else {
            settings.controllers.checkboxes.forEach(function (cb) {
              // Disabling the filter
              if (checkbox !== cb) {
                cb.classList.remove('js-active');
              }
              // Enabling the filter
              else {
                cb.classList.add('js-active');
              }
            });
          }

          // Get all the active filters
          settings.controllers.checkboxes.forEach(function (cb) {
            if (containsClass(cb, 'js-active')) settings.value.push(cb.value);
          });
          _this.applyFilter();
        });
      });
      settings.controllers.select.addEventListener('change', function (e) {
        e.preventDefault();
        settings.value = [];

        // If we allow for multiple values
        if (settings.type === 'multiple') {
          // Get all the active filters
          for (var i = 0; i < settings.controllers.select.selectedOptions.length; i++) {
            settings.value.push(settings.controllers.select.selectedOptions[i].value);
          }
        } else {
          // Get all the active filters
          settings.value.push(settings.controllers.select.value);
        }
        _this.applyFilter();
      });
    });
  }
  _createClass(Filters, [{
    key: "getDataByIndex",
    value: function getDataByIndex(data, index) {
      var dataArray = [];
      for (var item in data) {
        if (Array.isArray(data[item])) {
          dataArray.push(data[item]);
        }
      }
      ;
      return dataArray[index];
    }
  }, {
    key: "applyFilter",
    value: function applyFilter() {
      var _this2 = this;
      clearTimeout(this.timeout);
      this.contentAreas.forEach(function (area) {
        // Indicates the page is about to load
        area.classList.add('js-waiting');
      });

      // Throttle the requests
      this.timeout = setTimeout(function () {
        _this2.contentAreas.forEach(function (area, index) {
          var i = 0;
          var prefix = '?';
          var url = _this2.url;

          // Indicates the page is loading
          area.classList.remove('js-waiting');
          area.classList.add('js-loading');

          // Generate the URL based on the current filters
          loopObject(_this2.filters, function (name, settings) {
            prefix = i === 0 ? '?' : '&';
            if (settings.value.length) {
              url += "".concat(prefix + name, "=").concat(settings.value.join(','));
              i += 1;
            }
            ;
          });

          // Ajax in the results
          ajax({
            url: url,
            success: function success(response) {
              // const data = this.getDataByIndex(JSON.parse(response).data, index);

              // Clear the current content
              area.innerHTML = response;
              setTimeout(function () {
                // Indicates the page has loaded
                area.classList.remove('js-loading');
                window.dispatchEvent(_this2.filterEvent);
                _this2.pagination();
                _this2.equalizers[index].Equalizer.update();
              }, 500);
            }
          });
        });
      }, 500);
    }
  }, {
    key: "pagination",
    value: function pagination() {
      var _this3 = this;
      var pagination = nodeArray(this.section.querySelectorAll('.js-filter--pagination a'));
      pagination.forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          clearTimeout(_this3.timeout);
          _this3.contentAreas.forEach(function (area) {
            // Indicates the page is about to load
            area.classList.add('js-waiting');
          });

          // Throttle the requests
          _this3.timeout = setTimeout(function () {
            _this3.contentAreas.forEach(function (area, index) {
              // Indicates the page is loading
              area.classList.remove('js-waiting');
              area.classList.add('js-loading');
              ajax({
                url: link.href.includes(_this3.url) ? link.href : _this3.url + '?' + link.href.split('?')[1],
                success: function success(response) {
                  // const data = this.getDataByIndex(JSON.parse(response).data, index);

                  // Clear the current content
                  area.innerHTML = response;
                  setTimeout(function () {
                    // Indicates the page has loaded
                    area.classList.remove('js-loading');
                    window.dispatchEvent(_this3.filterEvent);
                    _this3.pagination();
                    _this3.equalizers[index].Equalizer.update();
                  }, 500);
                }
              });
            });
          }, 500);
        });
      });
    }
  }]);
  return Filters;
}(); // import { nodeArray } from '@meteora-digital/helpers';
// export default class Filters {
//   constructor(container, onComplete) {
//     this.container = container;
//     this.selects = nodeArray(this.container.querySelectorAll('.js-filter--select'));
//     this.checkboxes = nodeArray(this.container.querySelectorAll('.js-filter--checkbox'));
//     this.items = nodeArray(this.container.querySelectorAll('.js-filter--item'));
//     this.filter = {};
//     this.filtered = [];
//     // Filtering
//     this.selects.forEach(select => {
//       select.addEventListener('change', () => this.applyFilter());
//     });
//     this.checkboxes.forEach(box => {
//       box.addEventListener('change', () => {
//         this.applyFilter();
//       });
//     });
//   }
//   applyFilter() {
//     this.filtered = [];
//     this.selects.forEach(select => this.getInputValue(select));
//     this.checkboxes.forEach(box => {
//       if (box.checked) this.getInputValue(box);
//     });
//     for (let i = 0; i < this.items.length; i += 1) {
//       let include = true;
//       for (let filter in this.filter) {
//         let tests = this.items[i].getAttribute(`data-filter-${filter}`).toLowerCase().split(',');
//         if (tests.length >= 2) {
//           include = (tests.filter((arrayItem) => (arrayItem.includes(this.filter[filter]))).length);
//         } else {
//           include = (tests[0].includes(this.filter[filter]));
//         }
//         if (!include) break;
//       }
//       if (include) this.filtered.push(this.items[i]);
//       this.items[i].style.display = (include) ? 'block' : 'none';
//       if (onComplete !== undefined && typeof onComplete === 'function') onComplete();
//     }
//     (this.filtered.length === 0) ? this.container.classList.add('no-results') : this.container.classList.remove('no-results');
//   }
//   getInputValue(input) {
//     let name = input.getAttribute('data-filter-name');
//     if (input.value !== '') {
//       this.filter[name] = input.value;
//     }else if (this.filter[name]) {
//       delete(this.filter[name]);
//     }
//   }
// }
export { Filters as default };